import {
  AVAILABLE_PLANS,
  AvailablePlansTypes,
  PlanRecordKeyTypes
} from '@constants/plans'

export const isUnavailablePlan = (planRecordKey: PlanRecordKeyTypes) =>
  !AVAILABLE_PLANS.includes(planRecordKey as AvailablePlansTypes)
